export const toLogScale = (value) => Math.log(value + 1);

export const fromLogScale = (value) => Math.exp(value) - 1;

export const floorToNearestZero = (value) => {
    const digits = String(Math.round(value)).length;
    const scale = 10 ** (digits - 1);
    return Math.floor(value / scale) * scale;
};

export const roundToNearestZero = (value) => {
    const digits = String(Math.round(value)).length;
    const scale = 10 ** (digits - 1);
    return Math.round(value / scale) * scale;
};

export const ceilToNearestZero = (value) => {
    const digits = String(Math.round(value)).length;
    const scale = 10 ** (digits - 1);
    return Math.ceil(value / scale) * scale;
};
